'use client'
import { useState, useContext } from 'react'

import { useRouter } from 'next/navigation'

import { AuthenticationAPI } from '@/library/entities/core/data/authentication'

import CardDefault from '@/library/blocks/cards/CardDefault'
import InputDefault from '@/library/blocks/forms/InputDefault'
import { COUNTRY_ID, IS_DEV, REGION } from '@/data/constants'
import ButtonWSpinner from '@/library/blocks/buttons/ButtonWSpinner'
import { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator } from '@/components/ui/input-otp'
import { UserContext } from '@/library/entities/core/user/contexts/UserContext'
import { toast } from 'sonner'

export default function UserCreateForm(props) {
  const STEPS = {
    CREATE_ACCOUNT: 1,
    ENTER_CODE: 2,
  }
  const {
    countryId = COUNTRY_ID,
    onSuccess = () => { },
  } = props

  let formDataPayload = {}
  if (IS_DEV) {
    formDataPayload = {
      username: 'hasselito',
      first_name: 'Hassan',
      last_name: 'Mian',
      email: 'mian@willandskill.se',
      password_1: 'MystikaL!2k12',
      password_2: 'MystikaL!2k12',
    }
  }
  const { loginWithCode } = useContext(UserContext)
  const [formData, setFormData] = useState(formDataPayload)
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [registrationStep, setRegistrationStep] = useState(STEPS.CREATE_ACCOUNT)
  const [userLoginCodeLoading, setUserLoginCodeLoading] = useState(false)
  const [userLoginCodeErrors, setUserLoginCodeErrors] = useState({})
  const router = useRouter()

  const handleOnChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleOnFormSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    formData['region'] = REGION
    const { data, response } = await AuthenticationAPI.createUser(formData)
    setIsLoading(false)

    if (response.ok) {
      setRegistrationStep(STEPS.ENTER_CODE)
    } else {
      setErrors(data)
    }
  }

  const renderStepCreateAccount = () => {
    return (
      <>
        <p className="mb-4">Enter your information to create an account</p>
        <form onSubmit={handleOnFormSubmit}>
          <InputDefault
            name="username" type="text" label="Username"
            isRequired={true}
            placeholder="Enter your username"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="first_name" type="text" label="First Name"
            isRequired={true}
            placeholder="Enter your first name"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="last_name" type="text" label="Last Name"
            isRequired={true}
            placeholder="Enter your last name"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="email" type="email" label="Email"
            isRequired={true}
            placeholder="Enter your email"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="password_1" type="password" label="Password"
            isRequired={true}
            placeholder="Enter your password"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="password_2" type="password" label="Confirm Password"
            isRequired={true}
            placeholder="Please confirm your passwod"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          {errors.non_field_errors && (
            <div className="pl-4 mb-2">
              {errors.non_field_errors.map((error, index) => {
                return <p key={index} className="text-danger text-xs">{error}</p>

              })}

            </div>
          )}
          <ButtonWSpinner
            type="submit"
            className="w-full"
            isLoading={isLoading}
            label="Create Account"
            color="primary"
          />
        </form>
      </>
    )
  }

  const handleOnChangeCode = async (value) => {
    setUserLoginCodeLoading(true)
    if (value.length === 6) {
      const { success, errors } = await loginWithCode(formData.email, value)
      if (success) {
        onSuccess()
        toast.success('You are now logged in')
      } else {
        toast.error('Invalid code')
        setUserLoginCodeErrors(errors)
      }
    }
    setUserLoginCodeLoading(false)
  }

  const renderStepEnterCode = () => {
    return (
      <div className="flex flex-col items-center justify-center gap-8">
        <div className="text-center">
          <p className="text-lg font-bold">We've sent a code to your email.</p>
          <p className="text-sm">Enter the code to activate your account.</p>
        </div>
        <InputOTP maxLength={6} onChange={handleOnChangeCode}>
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
          </InputOTPGroup>
          <InputOTPSeparator />
          <InputOTPGroup>
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>
        {userLoginCodeErrors && (
          <div className="font-bold">
            <p className="text-danger text-xs">{userLoginCodeErrors.error}</p>
          </div>
        )}
        <ButtonWSpinner
          type="button"
          className=""
          isLoading={userLoginCodeLoading}
          label="Send Code"
          color="primary"
        // onClick={handleOnResendCode}
        />
      </div>
    )
  }

  return (
    <>
      <CardDefault>
        {registrationStep === STEPS.CREATE_ACCOUNT && renderStepCreateAccount()}
        {registrationStep === STEPS.ENTER_CODE && renderStepEnterCode()}
      </CardDefault>
    </>
  )
}
